import React, { Component } from 'react';
import { Provider } from 'react-redux';
import { store, persistor } from './store';
import $ from 'jquery';
import ApplicationTree from './ApplicationTree';
import AxiosInterceptor from './AxiosInterceptor';
import { PersistGate } from 'redux-persist/integration/react';
import './App.css';

AxiosInterceptor();
class App extends Component {
  componentDidMount() {
    $(document).scroll(function () {
      var y = $(this).scrollTop();
      if (y > 1) {
        $('#page').addClass('scrolled');
      } else {
        $('#page').removeClass('scrolled');
      }
    });
  }

  render() {
    return (
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <ApplicationTree />
        </PersistGate>
      </Provider>
    );
  }
}

export default App;
